// @ts-nocheck
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { inject, observer } from "../../../stores/mobx-compat";

import PageHeader from '../../ui/PageHeader';
import FilterBar from '../../ui/FilterBar';
import FormGroup from '../../ui/FormGroup';
import Select from '../../ui/Select';
import Switch from '../../ui/Switch';
import { FullSpinner } from '../../ui/Spinner';

import Statistics from './Statistics';
import Chart from './Chart';
import SummaryOverview from './SummaryOverview';
import SetupProgress from './SetupProgress';

const timeOptions = [
  { value: 1, label: '1 month' },
  { value: 3, label: '3 months' },
  { value: 6, label: '6 months' },
  { value: 12, label: '1 year' },
];

class Dashboard extends Component {
  componentDidMount() {
    this.props.store.realtime.bindRealtimeData()
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('bindRealtimeData failed:', err);
        this.props.store.failure(`Failed to get realtime data: ${err && err.message ? err.message : 'unknown error'}`);
      });
  }

  render() {
    const {
      loading, rawAnalytics, filters, setTimeSpan, percentView, setFilters,
    } = this.props.store.analytics;
    const setupStatus = typeof this.props.store.auth.setupStatus === 'function' ? this.props.store.auth.setupStatus() : this.props.store.auth.setupStatus;

    if (loading.getRawAnalytics || !this.props.store.appInitFlag) {
      return <FullSpinner label="Fetching metrics — this can take a moment" />;
    }

    const domains = rawAnalytics[filters.timeSpanInMonths] || {};
    const paths = (filters.domain && domains[filters.domain]) || {};

    return (
      <>
        <PageHeader
          eyebrow="Form Capture"
          title={<>Recover what <em>almost</em> converted.</>}
          sub="Live overview of forms started, abandoned, and recovered across your sites."
        />

        {this.props.store.forms.loading === false && setupStatus && <SetupProgress />}

        <FilterBar
          columns={4}
          chips={(
            <div className="flex items-center gap-2 ml-auto">
              <span className="mov-mono text-[11px] uppercase tracking-wider text-mov-ink-mute">Percent view</span>
              <Switch
                checked={percentView}
                onChange={() => this.props.store.analytics.togglePercentView()}
                ariaLabel="Percent view"
              />
            </div>
          )}
        >
          <FormGroup label="Time range">
            <Select
              value={filters.timeSpanInMonths}
              onChange={(e) => setTimeSpan(e, { value: Number(e.target.value) })}
            >
              {timeOptions.map((o) => (
                <option key={o.value} value={o.value}>From the past {o.label}</option>
              ))}
            </Select>
          </FormGroup>
          <FormGroup label="Domain">
            <Select
              value={filters.domain || ''}
              onChange={(e) => setFilters({ domain: e.target.value || null, path: null })}
            >
              <option value="">All domains</option>
              {Object.keys(domains).map((d) => (
                <option key={d} value={d}>{d}</option>
              ))}
            </Select>
          </FormGroup>
          <FormGroup label="Form URL">
            <Select
              value={filters.path || ''}
              disabled={!filters.domain}
              onChange={(e) => setFilters({ path: e.target.value || null })}
            >
              <option value="">All paths</option>
              {Object.keys(paths).map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </Select>
          </FormGroup>
        </FilterBar>

        <Statistics />

        <Chart />

        <SummaryOverview />
      </>
    );
  }
}

export default inject('store')(observer(Dashboard));
